import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import constants from "../constants/constants"
import { useEffect, useState } from "react";

export default function Contact() {
    const [popup, setPopup] = useState(false)
    const [formData, setFormData] = useState({
        Name: "",
        "Email Address": "",
        Message: "",
    });
    const [formErrors, setFormErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        // Clear error when user starts typing
        if (formErrors[name]) {
            setFormErrors(prev => ({
                ...prev,
                [name]: ""
            }));
        }
    };

    // Email validation function
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    // Form validation function
    const validateForm = () => {
        const errors = {};
        
        // Check required fields
        if (!formData.Name.trim()) {
            errors.Name = "Name is required";
        }
        
        if (!formData["Email Address"].trim()) {
            errors["Email Address"] = "Email is required";
        } else if (!validateEmail(formData["Email Address"])) {
            errors["Email Address"] = "Please enter a valid email address";
        }
        
        if (!formData.Message.trim()) {
            errors.Message = "Message is required";
        }
        
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    async function submitForm(event) {
        event.preventDefault();

        // Validate form before submission
        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);

        const object = {
            ...formData,
            access_key: constants.EMAIL_ACCESS_KEY,
            subject: "New Contact Form Message",
        };

        try {
            const res = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify(object)
            });

            if (!res.ok) {
                throw new Error("Failed to send email");
            }

            const responseData = await res.json();

            if (responseData?.success) {
                console.log("Success", responseData);
                setPopup({ 
                    subject: 'Thanks for your message!', 
                    message: 'We will get back to you as soon as possible' 
                });
                // Clear form after successful submission
                setFormData({
                    Name: "",
                    "Email Address": "",
                    Message: "",
                });
                setFormErrors({});
            } else {
                setPopup({ 
                    subject: 'We encountered an error in sending this message', 
                    message: 'Please try again later' 
                });
            }
        } catch (err) {
            console.log(err);
            setPopup({ 
                subject: 'We encountered an error in sending this message', 
                message: 'Please try again later' 
            });
        } finally {
            setIsSubmitting(false);
        }
    }

    const [windowSize, setWindowSize] = useState(window.innerWidth);

    const onWindowResize = () => {
        setWindowSize(window.innerWidth);
    };
    useEffect(() => {
        window.addEventListener("resize", onWindowResize);
        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, []);

    return (
        <>
            <div className="w-full bg-light-grey flex flex-wrap gap-x-16 gap-y-10 justify-center py-16 px-7 min-h-[70vh]">
                <div>
                    <h4 className="font-mont font-semibold text-black text-lg min-w-[20vw]">Questions? I'm Here To Help</h4>
                    <form id="form" onSubmit={submitForm} className="mt-6 flex flex-col">
                        <div className="form-item">
                            <label className="form-label">Name*</label>
                            <input 
                                className={`form-input ${formErrors.Name ? 'border-red-500' : ''}`}
                                name="Name" 
                                placeholder="Full Name"
                                value={formData.Name}
                                onChange={handleInputChange}
                            />
                            {formErrors.Name && (
                                <p className="text-red-500 text-sm mt-1">{formErrors.Name}</p>
                            )}
                        </div>
                        <div className="form-item">
                            <label className="form-label">Email*</label>
                            <input 
                                className={`form-input ${formErrors["Email Address"] ? 'border-red-500' : ''}`}
                                name="Email Address" 
                                type="email"
                                placeholder="Email Address"
                                value={formData["Email Address"]}
                                onChange={handleInputChange}
                            />
                            {formErrors["Email Address"] && (
                                <p className="text-red-500 text-sm mt-1">{formErrors["Email Address"]}</p>
                            )}
                        </div>
                        <div className="form-item">
                            <label className="form-label">Message*</label>
                            <textarea 
                                className={`form-input resize-none h-32 ${formErrors.Message ? 'border-red-500' : ''}`}
                                name="Message" 
                                placeholder="Your Message"
                                value={formData.Message}
                                onChange={handleInputChange}
                            />
                            {formErrors.Message && (
                                <p className="text-red-500 text-sm mt-1">{formErrors.Message}</p>
                            )}
                        </div>
                        <button 
                            type="submit" 
                            disabled={isSubmitting}
                            className={`btn-primary self-start rounded-none px-10 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
                        >
                            {isSubmitting ? 'Sending...' : 'Send'}
                        </button>
                    </form>
                </div>
                <div>
                    <iframe className="contact-map"
                        src={constants.MAP}
                        height="365" width={`${windowSize > 900 ? '500' : '300'}`} style={{ border: 0 }} allowfullscreen="" loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"></iframe>

                    <div className="flex flex-col gap-y-2 text-black mt-6">
                        <h2 className="text-black text-2xl">{constants.AGENT_NAME}</h2>
                        <p className="italic">{constants.AGENT_TITLE}, {constants.BROKERAGE}</p>
                        <p><FontAwesomeIcon icon={faPhone} className="text-logo-main fa-lg" /> {constants.AGENT_NUMBER} </p>
                        <p><FontAwesomeIcon icon={faEnvelope} className="text-logo-main fa-lg" /> {constants.AGENT_EMAIL} </p>
                    </div>
                </div>

            </div>
            {popup &&
                <>
                    <div className="backdrop" />
                    <div className="popup">
                        <h5 className="font-bold text-black text-lg">{popup.subject}</h5>
                        <p className="font-semibold text-med-grey tracking-wide mb-3">{popup.message}</p>
                        <button onClick={() => setPopup(false)} className="btn-primary">Close</button>
                    </div>
                </>}
        </>
    )
}